module.exports = __webpack_public_path__ + "img/gb9115_31.prt.b67ae7f9.jpg";